(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-post-carousel"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('rv-post-carousel')){
  customElements.define('rv-post-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();
      const signal=this.abort.signal;
      const track=this.querySelector('.rvpc__track');
      const prev=this.querySelector('[data-rvpc-prev]');
      const next=this.querySelector('[data-rvpc-next]');
      if(!track||!prev||!next)return;
      const originals=Array.from(track.children);
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      let hovered=false,touching=false,visible=false,selected=false,last=0,position=Math.abs(track.scrollLeft);
      const direction=()=>getComputedStyle(track).direction==='rtl'?-1:1;
      const period=()=>originals.length>1?Math.abs(originals[1].offsetLeft-originals[0].offsetLeft)*originals.length:0;
      originals.forEach(card=>{
        const clone=card.cloneNode(true);
        clone.removeAttribute('data-block-id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden','true');
        clone.setAttribute('inert','');
        clone.dataset.rvpcClone='';
        clone.querySelectorAll('[id]').forEach(el=>{
          const old=el.id;el.id=old+'-loop';
          clone.querySelectorAll('[clip-path]').forEach(path=>{
            if(path.getAttribute('clip-path')==='url(#'+old+')')path.setAttribute('clip-path','url(#'+el.id+')');
          });
        });
        track.appendChild(clone);
      });
      track.style.scrollSnapType='none';
      const move=step=>{
        const card=originals[0];
        const gap=parseFloat(getComputedStyle(track).columnGap)||14;
        const span=period();
        if(!span)return;
        position=((Math.abs(track.scrollLeft)+step*(card.getBoundingClientRect().width+gap))%span+span)%span;
        track.scrollTo({left:position*direction(),behavior:'instant'});
      };
      prev.hidden=false;next.hidden=false;
      prev.disabled=false;next.disabled=false;
      prev.addEventListener('click',()=>move(-1),{signal});
      next.addEventListener('click',()=>move(1),{signal});
      this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')hovered=true;},{signal});
      this.addEventListener('pointerleave',()=>{hovered=false;},{signal});
      this.addEventListener('pointerdown',()=>{touching=true;},{signal});
      window.addEventListener('pointerup',()=>{touching=false;},{signal});
      window.addEventListener('pointercancel',()=>{touching=false;},{signal});
      track.addEventListener('scroll',()=>{position=Math.abs(track.scrollLeft);},{passive:true,signal});
      track.addEventListener('keydown',e=>{
        if(e.target===track&&(e.key==='ArrowRight'||e.key==='ArrowLeft')){
          e.preventDefault();move(e.key==='ArrowRight'?direction():-direction());
        }
      },{signal});
      document.addEventListener('shopify:block:select',e=>{
        const card=originals.find(el=>el.dataset.blockId===e.detail.blockId);
        if(card){selected=true;position=Math.abs(card.offsetLeft-originals[0].offsetLeft);track.scrollTo({left:position*direction(),behavior:'instant'});}
      },{signal});
      document.addEventListener('shopify:block:deselect',()=>{selected=false;},{signal});
      this.visibilityObserver=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;},{threshold:0});
      this.visibilityObserver.observe(this);
      const tick=time=>{
        const elapsed=last?Math.min(time-last,50):0;last=time;
        const span=period();
        if(span>0&&visible&&!hovered&&!touching&&!selected&&!document.hidden&&!reduced.matches&&!this.contains(document.activeElement)){
          position=(position+elapsed*0.018)%span;
          track.scrollLeft=position*direction();
        }
        this.frame=requestAnimationFrame(tick);
      };
      this.frame=requestAnimationFrame(tick);
    }
    disconnectedCallback(){
      this.abort?.abort();this.abort=null;this.visibilityObserver?.disconnect();cancelAnimationFrame(this.frame);
      this.querySelectorAll('[data-rvpc-clone]').forEach(el=>el.remove());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-announcementbar"] && !Shopify.designMode) return;
  try {
    
  const marqueeAnnouncement = document.querySelector('.section-marquee-announcement');
  document.documentElement.style.setProperty('--marquee-height', `${marqueeAnnouncement.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();
})();
